import { ReactNode } from 'react';
import { Skeleton } from '@mui/material';

type TextFieldLoadingProps = { isLoading: boolean; children: ReactNode };

export const TextFieldLoading = ({ isLoading, children }: TextFieldLoadingProps) =>
  isLoading ? (
    <Skeleton className="form-section-item" variant="rectangular" width="100%" height={56} />
  ) : (
    (children as JSX.Element)
  );
